import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import moment from 'moment';
import { WalkInListView } from './walk-in-list';
import { useToggle } from '../../../infra/small-tools/use-toggle';
import { AddWalkInClient } from './add-walk-in-client';
import { useListState } from './use-list-state';
import config from '../../../../config';
import { getSessionShop, useSession } from '../../../infra/session';
export var WalkInListContainer = function (_a) {
    var onClose = _a.onClose;
    var _b = useState('current'), activeView = _b[0], setActiveView = _b[1];
    var session = useSession().data;
    var shop = getSessionShop(session);
    var _c = useState(moment().tz(shop.timezone).format(config.dateFormatISO)), selectedDate = _c[0], setSelectedDate = _c[1];
    var _d = useListState({
        activeView: activeView,
        date: selectedDate,
    }), table = _d.table, totalClients = _d.totalClients, clientFilter = _d.clientFilter, setClientFilter = _d.setClientFilter;
    var shouldShowClientsCounter = activeView === 'current';
    var shouldShowDatePicker = activeView === 'history';
    var addClientModalToggle = useToggle();
    return (_jsxs(_Fragment, { children: [_jsx(WalkInListView, { close: onClose, activeView: activeView, setActiveView: setActiveView, table: table, clientFilter: clientFilter, setClientFilter: setClientFilter, totalClients: totalClients, shouldShowClientsCounter: shouldShowClientsCounter, shouldShowDatePicker: shouldShowDatePicker, selectedDate: selectedDate, setSelectedDate: setSelectedDate, onAddClientClick: addClientModalToggle.setOn }), addClientModalToggle.isOn && _jsx(AddWalkInClient, { close: addClientModalToggle.setOff })] }));
};
